import { AnimatedBox } from './AnimatedBox'
import { EmptyState } from './EmptyState'
import { PageHeader } from './PageHeader'

/**
 * Lightweight placeholder for features not available yet.
 */
export const ComingSoonPage = ({ title, message }) => {
  return (
    <AnimatedBox>
      <PageHeader title={title} />
      <EmptyState
        title={`${title} is coming soon`}
        message={message || 'This section is planned for a future release.'}
      />
    </AnimatedBox>
  )
}
